<template>
    <the-mask
        v-model="model"
        class="form-control"
        :mask="['(##) ####-####', '(##) #####-####']"
        :required="required"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="inputDefault"
    />
</template>

<script>
export default {
  props: {
    value: null,
    input: { type: Function, default: null },
    required: { default: false },
    disabled: { default: false },
    placeholder: { default: '' }
  },
  methods: {
    inputDefault: function (val) {
      if (this.input) { this.input(val) }
    }
  },
  computed: {
    model: {
      get () {
        return this.$api.UI.Format.Telefone(this.value)
      },
      set (value) {
        this.$emit('input', this.$api.UI.Format.SomenteNumeros(value))
      }
    }
  }
}
</script>
